// extracted by mini-css-extract-plugin
export var animationContainer = "_g5-0";
export var asteriskIcon = "_g5-8";
export var conversationLeftSection = "_g5-4";
export var conversationListItem = "_g5-3";
export var conversationMiddleSection = "_g5-5";
export var conversationRightSection = "_g5-6";
export var detailsContent = "_g5-1";
export var listContainer = "_g5-7";
export var modalContent = "_g5-2";